import { Color } from '@models/Color';
import { Response } from '@models/Response';
import * as api from './api';

export function getColorsGroupedByName(): Promise<Response<Color>> {
  return api.get('colors/grouped');
}
